import React, { Component } from "react";
import { Form, Button, Col } from "react-bootstrap";
import Desplegable from "../../desplegable";
import * as utils from "../../../utils.js";
import $ from "jquery";

export default class FormDatosFamiliaresHermana extends Component {
  constructor(props) {
    super(props);
    this.DatosFamiliaresPut = this.DatosFamiliaresPut.bind(this);
  }

  // Función que hace el put de los datos familiares de la monja
  DatosFamiliaresPut(event) {
    event.preventDefault();
    let $this = $(this);
    let myform = document.getElementById("MyForm");
    let form = new FormData(myform);

    let settings = {
      url: process.env.REACT_APP_API_URL + "/hermanas/" + $this[0].props.DatosMonja.sister.id + "/datosFamiliares",
      method: "PUT",
      timeout: 0,
      xhrFields: {
        withCredentials: true,
      },
      processData: false,
      mimeType: "multipart/form-data",
      contentType: false,
      data: form,
    };

    // En caso de exito insertar los datos en el estado de la monja detalle
    $.ajax(settings)
      .done(function (response) {
        $this[0].props.setAlert("", "Se han editado los datos correctamente", "success");
        response = JSON.parse(response);
        $this[0].props.setDatosHermana(response);
      })
      .fail($this[0].props.ErrorHandling);
  }
  render() {
    // Para obtener la fecha actual para la restriccion html
    let today = utils.calculateDate();

    // default value de los campos son pasados por el props
    return (
      <Form className=" p-4" onSubmit={this.DatosFamiliaresPut} autoComplete="off" id="MyForm">
        <Desplegable
          Toogle={"Datos Padre"}
          Text={
            <Col>
              <Form.Row>
                <small className="mb-3">
                  Los campos con un <b>*</b> deben de ser rellenados.
                </small>
              </Form.Row>
              <Form.Group>
                <Form.Label>Nombre del Padre*</Form.Label>
                <Form.Control required type="text" name="fatherName" maxLength="45" autoComplete="nope" defaultValue={this.props.DatosMonja.sister.fatherName} />
              </Form.Group>
              <Form.Group>
                <Form.Label>Apellidos del Padre *</Form.Label>
                <Form.Control required type="text" name="fatherSurname" maxLength="100" autoComplete="nope" defaultValue={this.props.DatosMonja.sister.fatherSurname} />
              </Form.Group>
              <Form.Group>
                <Form.Label>País de Nacimiento *</Form.Label>
                <Form.Control required type="text" name="fatherCountry" maxLength="35" autoComplete="nope" defaultValue={this.props.DatosMonja.sister.fatherCountry} />
              </Form.Group>
              <Form.Group>
                <Form.Label>Provincia de Nacimiento</Form.Label>
                <Form.Control type="text" name="fatherProvince" maxLength="45" autoComplete="nope" defaultValue={this.props.DatosMonja.sister.fatherProvince} />
              </Form.Group>
              <Form.Group>
                <Form.Label>Ciudad o localidad de Nacimiento</Form.Label>
                <Form.Control maxLength="100" autoComplete="nope" type="text" name="fatherAddress" defaultValue={this.props.DatosMonja.sister.fatherAddress} />
              </Form.Group>
              <Form.Group>
                <Form.Label>Fecha de Nacimiento *</Form.Label>
                <Form.Control required autoComplete="nope" type="date" name="fatherBirthdate" max={today} defaultValue={this.props.DatosMonja.sister.fatherBirthdate} />
              </Form.Group>
              <fieldset>
                <Form.Group>
                  <Form.Label>¿Padre difunto? *</Form.Label>
                  <Form.Check
                    defaultChecked={this.props.DatosMonja.sister.fatherAlive === "Si" || this.props.DatosMonja.sister.fatherAlive === "" ? 1 : 0}
                    type="radio"
                    label="No"
                    value="Si"
                    name="fatherAlive"
                  />
                  <Form.Check defaultChecked={this.props.DatosMonja.sister.fatherAlive === "No" ? 1 : 0} type="radio" label="Si" value="No" name="fatherAlive" />
                </Form.Group>
              </fieldset>
            </Col>
          }
        />
        <Desplegable
          Toogle={"Datos Madre"}
          Text={
            <Col>
              <Form.Row>
                <small className="mb-3">
                  Los campos con un <b>*</b> deben de ser rellenados.
                </small>
              </Form.Row>
              <Form.Group>
                <Form.Label>Nombre de la Madre *</Form.Label>
                <Form.Control required maxLength="45" autoComplete="nope" type="text" name="motherName" defaultValue={this.props.DatosMonja.sister.motherName} />
              </Form.Group>
              <Form.Group>
                <Form.Label>Apellidos de la Madre *</Form.Label>
                <Form.Control required maxLength="100" autoComplete="nope" type="text" name="motherSurname" defaultValue={this.props.DatosMonja.sister.motherSurname} />
              </Form.Group>
              <Form.Group>
                <Form.Label>País de Nacimiento *</Form.Label>
                <Form.Control required maxLength="35" autoComplete="nope" type="text" name="motherCountry" defaultValue={this.props.DatosMonja.sister.motherCountry} />
              </Form.Group>
              <Form.Group>
                <Form.Label>Provincia de Nacimiento</Form.Label>
                <Form.Control maxLength="100" autoComplete="nope" type="text" name="motherProvince" defaultValue={this.props.DatosMonja.sister.motherProvince} />
              </Form.Group>
              <Form.Group>
                <Form.Label>Ciudad o localidad de Nacimiento</Form.Label>
                <Form.Control maxLength="100" autoComplete="nope" type="text" name="motherAddress" defaultValue={this.props.DatosMonja.sister.motherAddress} />
              </Form.Group>
              <Form.Group>
                <Form.Label>Fecha de Nacimiento *</Form.Label>
                <Form.Control required max={today} autoComplete="nope" type="date" name="motherBirthdate" defaultValue={this.props.DatosMonja.sister.motherBirthdate} />
              </Form.Group>
              <fieldset>
                <Form.Group>
                  <Form.Label>¿Madre difunta? *</Form.Label>
                  <Form.Check
                    defaultChecked={this.props.DatosMonja.sister.motherAlive === "Si" || this.props.DatosMonja.sister.motherAlive === "" ? 1 : 0}
                    type="radio"
                    label="No"
                    value="Si"
                    name="motherAlive"
                  />
                  <Form.Check defaultChecked={this.props.DatosMonja.sister.motherAlive === "No" ? 1 : 0} type="radio" label="Si" value="No" name="motherAlive" />
                </Form.Group>
              </fieldset>
            </Col>
          }
        />
        <Form.Group>
          <Button
            type="submit"
            variant="outline-success"
            className="btn btn-block mt-5"
            //onClick={this.props.handleButtonShow} TODO cuando se le da a guardar no se cierra el modal
            name="Datos Familiares"
          >
            Guardar
          </Button>
        </Form.Group>
      </Form>
    );
  }
}
